"use clietn";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardTitle,
} from "@/components/ui/card";
import { WEB_URL } from "@/constants";
import { useIsMobile } from "@/hooks/useMobile";
import { generateAndDownloadQr } from "@/lib/qrHelper";
import { QrCode } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

import React from "react";

type CardVisitProps = {
  title: string;
  desc: string;
  href: string;
  barcodeName?: string;
};

export default function CardVisit({
  desc,
  href,
  title,
  barcodeName,
}: CardVisitProps) {
  const isMobile = useIsMobile();

  const handleGenerate = () => {
    generateAndDownloadQr(
      `${WEB_URL}${href}`,
      "/assets/icons/dprd-pali-logo.png",
      barcodeName
    );
  };
  return (
    <Card className="relative overflow-hidden min-h-[22rem] bg-white hover:bg-primary duration-300 cursor-pointer group flex flex-col">
      <CardContent className="p-10 flex flex-col gap-y-4 relative z-10">
        <CardTitle className="text-xl md:text-2xl text-text-800 group-hover:text-white duration-0">
          {title}
        </CardTitle>
        <CardDescription className="text-base md:text-lg group-hover:text-white duration-0">
          {desc}
        </CardDescription>
      </CardContent>
      <CardFooter className="flex p-10 mt-auto w-full gap-x-4 z-20">
        <Link href={href}>
          <Button className="rounded-full min-w-32 group-hover:text-primary group-hover:bg-white">
            Isi Form
          </Button>
        </Link>
        <Button
          variant={"outline"}
          className="rounded-full group-hover:text-white group-hover:bg-text-800 group-hover:border-text-800"
          onClick={handleGenerate}
        >
          {isMobile ? <QrCode /> : "Download Barcode"}
        </Button>
      </CardFooter>
      {/*  */}
      <Image
        src={"/assets/images/relief-bg.svg"}
        alt="relif"
        width={300}
        height={200}
        className="absolute top-0 -right-6 w-auto h-[23rem] scale-150 md:scale-100  md:group-hover:scale-150  group-hover:-rotate-12 duration-500"
      />
    </Card>
  );
}
